import React, { ReactNode } from 'react'
import { Dropdown, DropdownActionProps, inputUploadVariants } from '@web/modules/core'
import { Button, ButtonProps, Loading } from '@tecsinapse/cortex-react'

const { uploadMedia, labelStyle } = inputUploadVariants()

interface UploadButtonProps {
  label?: string
  icon: ReactNode
  buttonVariants?: ButtonProps['variants']
  disabled?: boolean
  onlyIcon?: boolean
  isUploading?: boolean
  controller: AbortController
  handleUploadButton: () => void
  actions: DropdownActionProps[]
}

const InputUploadButton = ({
  label,
  icon,
  disabled,
  isUploading,
  buttonVariants,
  controller,
  handleUploadButton,
  onlyIcon,
  actions
}: UploadButtonProps) => {
  return (
    <Dropdown
      loading={false}
      actions={actions}
      placement={'bottom-start'}
      trigger={
        <div>
          {onlyIcon ? (
            <div onClick={handleUploadButton}>
              {isUploading ? <Loading className='h-4 w-4' /> : icon}
              {label && <p className={labelStyle()}>{isUploading ? 'Carregando' : label}</p>}
            </div>
          ) : (
            <Button
              disabled={disabled ?? isUploading}
              variants={buttonVariants}
              onClick={isUploading ? () => controller.abort() : handleUploadButton}
            >
              <div className={uploadMedia()}>
                {isUploading ? <Loading className='h-5 w-5' /> : icon}
                {label && <p className={labelStyle()}>{isUploading ? 'Carregando' : label}</p>}
              </div>
            </Button>
          )}
        </div>
      }
    />
  )
}

export default InputUploadButton
